/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import { columnCode } from '../../enums/columnCodeEnumsContractor';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import CommonCreationErrorsApp from "./Functionality/CommonCreationErrorsApp";
import {MODELS} from "../../Apis/Models";
import routes from "../../Routes/routes";
import HeadTittle from "../../components/HeadTittle";
import ButtonAction from "../../components/buttons/ButtonAction";
import DivContainerBody from "../../components/DivContainerBody";
import CreationErrorsBody from "./SubComponents/CreationErrorsBody";
import CreationErrorsSupplierVehicleApp from "./Functionality/CreationErrorsSupplierVehicleApp";

const CreationErrorsSuplierVehicle = () => {
    const props = CommonCreationErrorsApp({
        moduleId: MODELS.SupplierVehicle,
        goBack:routes.vehicleSupplier.list,
        validateSpaces:null,
        columns:new Array(7).fill({ type: 'text', width: 100 })
    });
    const {t, errorsArray, jRef, totalErrors, selectedErrorIndex} = props;
    const {handleConfirm, handleUploadFile} = CreationErrorsSupplierVehicleApp(props);

    return (
        <>
            <HeadTittle name={t('import')} link={routes.vehicleSupplier.list}>
                {totalErrors === 0 ? (
                    <ButtonAction
                        id='btn_cesv_import'
                        name='import'
                        className='btn-icon-accent-450'
                        onClick={handleConfirm}
                    />
                ) : (
                    <ButtonAction
                        id='btn_cesv_verify'
                        name='verify'
                        className='btn-icon-accent-450'
                        onClick={handleUploadFile}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <CreationErrorsBody
                    mainJRef={{name:t('excel'), jRef:jRef}}
                    totalErrors={totalErrors}
                    errorsArray={errorsArray}
                    selectedErrorIndex={selectedErrorIndex}
                    columnCode={columnCode}
                />
            </DivContainerBody>
        </>
    );
};

export default CreationErrorsSuplierVehicle;
